import { render, staticRenderFns } from "./RFReporter.vue?vue&type=template&id=8b51465c&scoped=true"
import script from "./RFReporter.vue?vue&type=script&lang=js"
export * from "./RFReporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b51465c",
  null
  
)

export default component.exports